import { CSSProperties } from 'react';
import { GroupBase, OptionProps, StylesConfig } from 'react-select';
import { getColor } from '@/utils/getThemeColor';
import { Obj } from '@/types/common';
import { CustomStylesArgs } from './types';
import { MAX_MENU_HEIGHT } from './constants';

const textStyle: CSSProperties = {
  // lineHeight: '32px',
  color: '#414042',
  fontFamily: 'Geologica',
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
};

export function getCustomStyles<T extends Obj>({
  isError,
  controlStyles,
  multiValueStyleOptions,
}: CustomStylesArgs<T>): StylesConfig<T, false | true> {
  return {
    container: (provided) => {
      return {
        ...provided,
        width: '100%',
        ...controlStyles?.containerStyles,
      };
    },
    control: (provided, state) => {
      return {
        ...provided,
        ...textStyle,
        minHeight: 48,
        border: `1.5px solid ${isError ? '#E73331' : state.isFocused ? '#414042' : '#4140421A'} `,
        boxShadow: 'none',
        background: state.isDisabled ? '#4140421A' : 'white',
        borderRadius: 12,
        cursor: 'pointer',
        padding: !state.hasValue || !state.isMulti ? '0 16px 0 1rem' : '8px 16px 8px 8px',
        ...controlStyles?.controlStyles,
        '&:hover': {
          borderColor: '#414042',
        },
      };
    },
    option: (provided, state: OptionProps<T, false | true, GroupBase<T>>) => {
      return {
        ...provided,
        ...textStyle,
        backgroundColor: state.isSelected ? '#eef0f6' : state.isFocused ? '#eef0f6' : '',
      };
    },
    valueContainer: (provided) => {
      return {
        ...provided,
        ...textStyle,
        padding: 0,
        alignItems: 'center',
        // margin: '4px 0',
        margin: 0,
        gap: 8,
      };
    },
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      // paddingRight: 16,
      '& div': {
        padding: 0,
      },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: 0,
      color: '#102340',
      '&:hover': {
        color: '#102340',
      },
    }),
    input: (provided) => ({
      ...provided,
      ...textStyle,
      margin: 0,
      padding: 0,
    }),
    placeholder: (provided) => ({
      ...provided,
      ...textStyle,
      fontSize: 16,
      lineHeight: '32px',
      color: 'rgba(23, 30, 55, 0.3)',
      // paddingLeft: '1rem',
    }),
    singleValue: (provided) => ({
      ...provided,
      ...textStyle,
    }),
    menu: (provided) => ({
      ...provided,
      height: 'fit-content',
      maxHeight: MAX_MENU_HEIGHT,
      zIndex: 5,
      width: '95%',
      left: 4,
      marginBottom: 20,
      ...controlStyles?.menuStyles,
    }),
    menuList: (provided) => ({
      ...provided,
      height: 'fit-content',
      maxHeight: MAX_MENU_HEIGHT,
    }),
    multiValue: (provided, state) => {
      const backgroundColor =
        multiValueStyleOptions && state.data
          ? getColor(state.data[multiValueStyleOptions.backgroundColorDataKey], 'white')
          : '#f5f5f5';
      const borderColor =
        multiValueStyleOptions && state.data
          ? getColor(state.data[multiValueStyleOptions.borderColorDataKey])
          : '#ECECEC';

      return {
        ...provided,
        ...textStyle,
        backgroundColor,
        border: `1.5px solid ${borderColor}`,
        borderRadius: 8,
        fontSize: 16,
        lineHeight: '16px',
        padding: '4px 8px',
        // maxHeight: 24,
        height: '100%',
        alignItems: 'center',
        // margin: 3,
        margin: 0,
        columnGap: 8,
      };
    },
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: 12,
      lineHeight: '16px',
      cursor: 'default',
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      display: typeof state.data === 'object' && state.data.isFixed ? 'none' : 'contents',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    }),
  };
}
